const currentDate = new Date();

const dateMinus30Years = new Date(currentDate);
dateMinus30Years.setFullYear(dateMinus30Years.getFullYear() - 30);

export const under30EnrolledTotalCalculation = (props: any) => {
    const {uoas, fields} = props;
    const birthDateField = fields.find((field: any) => field.key === 'data-di-nascita-attenzione-inserire-la-data-di-nascita-corretta-e-non-una-data-recente');

    if (!birthDateField) return 0;

    const totalCount = uoas.filter((uoa: any) => {
        const value = uoa.custom_field_values.find((custom_field_value: any) => custom_field_value.field_id === birthDateField.id);

        return value ? new Date(value.stored_value) < dateMinus30Years : false;
    }).length;

    return (totalCount / uoas.length * 100).toFixed(2);
}